import { CampaignSocialMediaType } from '@anytag/graphql';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { Option } from '@anytag/shared-types';
import { getSocialMediaText } from '@anytag/shared-utils';

export const useMarketplacePromotionMethodOptions = () => {
  const socialOptions: Option<CampaignSocialMediaType>[] = [
    CampaignSocialMediaType.FACEBOOK,
    CampaignSocialMediaType.INSTAGRAM,
    CampaignSocialMediaType.YOUTUBE,
    CampaignSocialMediaType.INSTAGRAM_STORY,
    CampaignSocialMediaType.TWITTER,
    CampaignSocialMediaType.TIKTOK
  ].map((value) => ({ value, label: getSocialMediaText(value) }));

  const promotionMethodOptions: Option<CampaignSocialMediaType>[] = useTranslateOptions([
    { label: 'Select all', value: CampaignSocialMediaType.UNSELECT },
    ...socialOptions,
    { label: 'Others(Website, Offline)', value: CampaignSocialMediaType.OTHER }
  ]);

  return { promotionMethodOptions };
};
